import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { Card } from '../../../../../../shared/card/card'
import { useApiFormNodeCourse } from '../../../../../../api-new/state/content'
import { IconEdit } from '../../../../../../shared/icon/icon'
import { Route, useRouteMatch } from '../../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { AssetList } from '../../common/assets/asset-list'
import { CourseMenu } from '../../common/menu/node-actions'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleJsonEditor } from '../../../../../../shared/form-simple/form-json-editor'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'
import { useDataContext } from '../data-context'
import { NodeCourseVersionList } from '../../common/assets/node-course-version-list'

export const NodeCourseEditSys = ({ parentURL, nodeID }) => {
  const { url } = useRouteMatch()

  const dataContext = useDataContext()

  const apiFormNodeCourse = useApiFormNodeCourse()

  const handleMatch = () => apiFormNodeCourse.get(nodeID)

  const handleSubmit = async data => {
    await apiFormNodeCourse.put(data.id, data)
    dataContext.reload()
  }

  const HeaderMenu = () => <CourseMenu place="header" url={parentURL} node={apiFormNodeCourse.form} nodeID={nodeID} />

  return (
    <React.Fragment>
      {/* Assets and Version metadata are the node's menu pages, mounted under
          this address: they are no pages of this one's (audit F16). */}
      <BreadcrumbView text="Sys admin edit" Icon={IconEdit} onMatch={handleMatch} notOver={['assets', 'versions']}>
        <CardFullHeightScrollY title="Sys admin edit" HeaderMenu={HeaderMenu}>
          <Card>
            <FormSimple state={apiFormNodeCourse.form} onSubmit={handleSubmit}>
              <FormSimpleText name="name" />
              <FormSimpleJsonEditor name="metadata" />
              <FormSimpleSubmitEdit />
            </FormSimple>
          </Card>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/assets`}>
        <AssetList parentURL={url} nodeID={nodeID} />
      </Route>

      <Route path={`${url}/versions`}>
        <NodeCourseVersionList parentURL={url} nodeID={nodeID} />
      </Route>
    </React.Fragment>
  )
}
